import { useDashboardStore } from '@/state/store';

/**
 * Audio-mute toggle for the header.
 *
 * Default is muted -- the audio dispatcher only starts playing
 * cues once the user explicitly clicks unmute (also satisfies the
 * browser autoplay gesture-required policy).  Choice persists in
 * localStorage via the store action.
 */
export function AudioMuteToggle() {
  const muted = useDashboardStore((s) => s.audioMuted);
  const setMuted = useDashboardStore((s) => s.setAudioMuted);
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!muted}
      aria-label={muted ? 'Unmute audio cues' : 'Mute audio cues'}
      title={
        muted
          ? 'Включить аудио-cue\'ы дашборда. Backend кодирует подсказки в scene_hint.audio_cue: ka-ching на order.filled, sirena на frozen, beep на session boundary и т.п.'
          : 'Выключить аудио. Cue\'ы продолжают приходить с backend\'а, но не воспроизводятся.'
      }
      onClick={() => setMuted(!muted)}
      style={{
        background: muted ? 'transparent' : '#1f6feb',
        color: muted ? '#8b949e' : 'white',
        border: '1px solid #30363d',
        borderRadius: 6,
        padding: '2px 8px',
        fontSize: 12,
        fontWeight: 700,
        cursor: 'pointer',
        letterSpacing: 0.4,
        minHeight: 24,
        minWidth: 32,
        fontFamily: 'inherit',
      }}
    >
      {muted ? '🔇' : '🔊'}
    </button>
  );
}
